import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import Me from "../helpers/me";
import App from "../helpers/app";
import Api from "../helpers/api";
import {take} from "rxjs/operators";
import * as moment from 'moment'
import { JwtHelper } from "../helpers/jwt-helper";
import { MatriculaServidorHelper } from "../shared/services/matricula-servidor.helper";

declare var ApexCharts: any;

// Interface para as estatísticas
interface EstatisticasContrato {
  mais_longo: { dias: number; percentual: number };
  media: number;
  mediana: number;
  mais_curto: { dias: number; percentual: number };
}

interface DistribuicaoItem {
  dias: number;
  percentual: number;
}

interface ContribuicaoGeral {
  dias_totais: number;
  total_contratos: number;
  distribuicao_regime: {
    rpps: DistribuicaoItem;
    inss: DistribuicaoItem;
  };
  distribuicao_tipo: {
    magisterio: DistribuicaoItem;
    outros: DistribuicaoItem;
  };
  averbacao: {
    averbado: DistribuicaoItem;
    nao_averbado: DistribuicaoItem;
  };
  estatisticas_contratos: EstatisticasContrato;
}

interface ContribuicaoRegime {
  dias_totais: number;
  percentual_do_total: number;
  total_contratos: number;
  distribuicao_tipo: {
    magisterio: DistribuicaoItem;
    outros: DistribuicaoItem;
  };
  averbacao: {
    averbado: DistribuicaoItem;
    nao_averbado: DistribuicaoItem;
  };
  estatisticas_contratos: EstatisticasContrato;
}

interface ContribuicaoMagisterio {
  dias_totais: number;
  percentual_do_total: number;
  percentual_vs_nao_magisterio: number;
  total_contratos: number;
  distribuicao_regime: {
    rpps: DistribuicaoItem;
    inss: DistribuicaoItem;
  };
  averbacao: {
    averbado: DistribuicaoItem;
    nao_averbado: DistribuicaoItem;
  };
  estatisticas_contratos: EstatisticasContrato;
}

interface AproveitamentoProfissional {
  dias_uteis_decorridos: number;
  dias_contribuicao: number;
  tempo_ocioso: number;
  percentual_medio_contribuicao: number;
}

interface Concomitancia {
  tem_concomitancia: boolean;
  dias_concomitantes: number;
  dias_brutos: number;
  dias_unicos: number;
  percentual_sobre_brutos: number;
}

interface EstatisticasServidor {
  id_servidor: number;
  contribuicao_geral: ContribuicaoGeral;
  contribuicao_inss: ContribuicaoRegime;
  contribuicao_rpps: ContribuicaoRegime;
  contribuicao_magisterio: ContribuicaoMagisterio;
  aproveitamento_profissional: AproveitamentoProfissional;
  concomitancia?: Concomitancia;
}

@Component({
  selector: 'app-tempos',
  templateUrl: './tempos.component.html',
  styleUrls: ['./tempos.component.scss']
})
export class TemposComponent implements OnInit, AfterViewInit {
  @ViewChild('confirmDeleteModal', { static: true }) confirmDeleteModal: TemplateRef<any>;
  
  apiCall = this.api.new().silent();
  page = 1
  pageSize = 100
  pageC = 1
  pageSizeC = 100
  idServidor
  idCidade: number = null;
  isConferidor: boolean = false;
  tspConferido: boolean = false;
  servidor: any = null;
  matriculas: any[] = [];
  todosTempos: any[] = [];
  tempos = [];
  filtroMatricula: 'todos' | 'matricula' | 'sem_matricula' = 'todos';
  idMatriculaFiltro: number = null;
  filtrarContratosMatricula = false;
  certidoes = [];
  
  // Dados das estatísticas
  estatisticas: EstatisticasServidor = null;
  private estatisticasRequestId = 0;
  certidaoEmEdicao = {
    id: null,
    numero_certidao: null,
    data_certidao: null,
  }
  tempo = {
    id: null,
    id_servidor: null,
    id_matricula: null,
    cnpj_cpf_empregador: null,
    nome_empregrador: null,
    numero_certidao: null,
    data_certidao: null,
    rpps_rgps: 0,
    averbado: null,
    data_entrada: null,
    tempo_total: null,
    data_fim: null,
    tempo_bruto: null,
    seq: null,
    em_sala_de_aula: 2
  }
  tempoSubmetido = false
  salvandoTempo = false
  sortColumn: string = '';
  sortDirection: string = 'asc'; 
  RPPSRGPS = [

    {
      id: 0,
      descricao: 'RPPS',
    },{
      id: 1,
      descricao: 'RGPS',
    }]
    averbado = [
      {
        id: 1,
        name: 'Sim',
      },{
        id: 0,
        name: 'Não',
      }
    ]
  
  emSalaDeAula = [
    {
      id: 1,
      name: 'Sim',
    },{
      id: 2,
      name: 'Não',
    }
  ]
  
  tempoTotalCadastrado= 0
  tempoTotalAverbado= 0
  tempoTotalRPPS= 0
  tempoTotalRPPSAverbado= 0
  tempoTotalINSS= 0
  tempoTotalINSSAverbado= 0
  tempoTotalRPPSProfessor = 0
  tempoTotalINSSProfessor = 0
  
  // Propriedades para seleção múltipla
  selectedTempos: Set<number> = new Set();
  selectAll = false;
  
  // Propriedades para filtro de eixos
  filtroEixo: string = 'todos';
  
  // Instância do gráfico
  chart: any = null;
  
  // Configurações do gráfico timeline
  chartOptions: any = {
    series: [],
    chart: {
      height: 400,
      type: 'rangeBar',
      toolbar: {
        show: true
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '80%'
      }
    },
    xaxis: {
      type: 'datetime'
    },
    stroke: {
      width: 1
    },
    fill: {
      type: 'solid',
      opacity: 0.8
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      show: true,
      showForSingleSeries: true,
      showForNullSeries: true,
      showForZeroSeries: true
    },
    colors: ['#28a745', '#007bff'], // Verde para RPPS, Azul para INSS
    tooltip: {
      custom: function({series, seriesIndex, dataPointIndex, w}) {
        const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
        const startDate = new Date(data.y[0]);
        const endDate = new Date(data.y[1]);
        const days = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
        
        return `
          <div style="padding: 15px; background: white; border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); min-width: 250px;">
            <div style="margin-bottom: 8px; font-size: 14px; font-weight: 600; color: #333; border-bottom: 1px solid #eee; padding-bottom: 5px;">
              ${data.tipo || 'Tempo de Contribuição'}
            </div>
            <div style="margin-bottom: 5px; font-size: 13px;"><strong>Período:</strong> ${startDate.toLocaleDateString('pt-BR')} ~ ${endDate.toLocaleDateString('pt-BR')}</div>
            <div style="margin-bottom: 5px; font-size: 13px;"><strong>CNPJ:</strong> ${data.cnpj || 'N/A'}</div>
            <div style="margin-bottom: 5px; font-size: 13px;"><strong>Total:</strong> ${days} Dias</div>
            <div style="margin-bottom: 5px; font-size: 13px;"><strong>Empregador:</strong> ${data.empregador || 'N/A'}</div>
            <div style="margin-bottom: 5px; font-size: 13px;"><strong>Matrícula:</strong> ${data.matricula || 'Sem matrícula'}</div>
            <div style="margin-bottom: 5px; font-size: 13px;"><strong>Averbado:</strong> ${data.averbado || 'N/A'}</div>
          </div>
        `;
      }
    }
  };
  
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private api: Api
  ) {
  }
  async ngOnInit() {
    const self = this;
    const dadosUsuario = self.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario || {}));
    self.isConferidor = !!(dadosUsuario && dadosUsuario.token && JwtHelper.isConferidor(dadosUsuario.token));
    self.resetaTempo()
    self.tempoTotalCadastrado = 0
    self.tempoTotalAverbado = 0
    self.tempoTotalINSS = 0
    self.tempoTotalINSSAverbado = 0
    self.tempoTotalRPPS = 0
    self.tempoTotalRPPSAverbado = 0
    
    // Limpar seleções
    self.selectedTempos.clear();
    self.selectAll = false;
    self.tempoTotalRPPSProfessor = 0
    self.tempoTotalINSSProfessor = 0
    self.route.queryParams.pipe(take(1)).subscribe( parametros => {
      if (parametros['id']) {
        self.idServidor = parametros['id'];
      }
      self.idCidade = parametros['idCidade']
        ? parseInt(parametros['idCidade'], 10)
        : (json.user && json.user.cidade ? +json.user.cidade : null);
      const idMatriculaUrl = parametros['id_matricula']
        ? parseInt(parametros['id_matricula'], 10) : null;
      if (parametros['filtro_matricula'] === 'sem_matricula') {
        self.filtroMatricula = 'sem_matricula';
        self.idMatriculaFiltro = null;
      } else if (idMatriculaUrl) {
        self.filtroMatricula = 'matricula';
        self.idMatriculaFiltro = idMatriculaUrl;
      } else {
        self.filtroMatricula = 'todos';
        self.idMatriculaFiltro = null;
      }
    });
    self.carregarConferenciaLocal();
    self.todosTempos = [];
    self.tempos = [];

    await self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    const certidoes = await self.apiCall.get('servidor/temposervico/certidao/recupera?id_servidor='+self.idServidor).pipe(take(1)).toPromise()
    self.certidoes = JSON.parse(JSON.stringify(certidoes));
    const contextoCidade = self.idCidade ? '&id_cidade=' + self.idCidade : '';
    const servidor = await self.apiCall.get('servidor?id=' + self.idServidor + contextoCidade).pipe(take(1)).toPromise()
    self.servidor = JSON.parse(JSON.stringify(servidor || {}));
    self.matriculas = MatriculaServidorHelper.getMatriculas(self.servidor, self.idCidade);
    const tempos = await self.apiCall.get('servidor/temposervico/todos?id_servidor=' + self.idServidor + contextoCidade + '&filtro_matricula=todos').pipe(take(1)).toPromise()
    // A tela sempre abre ordenada por seq, inclusive após salvar, editar ou excluir.

    self.todosTempos = JSON.parse(JSON.stringify(tempos || [])).sort((a, b) => self.comparaPorSeq(a, b)).map((item, index) => ({...item, numeroLinha: index + 1}))
    self.sortColumn = 'seq'
    self.sortDirection = 'asc'
    self.validarFiltroMatriculaAtual()
    self.atualizarUrlFiltroMatricula()
    self.tempos = self.getTemposFiltrados()
    for(let item of self.tempos){
      self.tempoTotalCadastrado = self.tempoTotalCadastrado + +item.tempo_bruto
      if(item.averbado == 1){
        self.tempoTotalAverbado = self.tempoTotalAverbado + +item.tempo_bruto
      }
      if(item.rpps_rgps == 0){
        if(item.averbado == 1){
          self.tempoTotalRPPSAverbado = self.tempoTotalRPPSAverbado + +item.tempo_bruto
        }
        self.tempoTotalRPPS = self.tempoTotalRPPS + +item.tempo_bruto
        if(item.em_sala_de_aula === 1){
          self.tempoTotalRPPSProfessor = self.tempoTotalRPPSProfessor + +item.tempo_bruto
        }
      }else if(item.rpps_rgps == 1){
        if(item.averbado == 1){
          self.tempoTotalINSSAverbado = self.tempoTotalINSSAverbado + +item.tempo_bruto
        }
        self.tempoTotalINSS = self.tempoTotalINSS + +item.tempo_bruto
        if(item.em_sala_de_aula === 1){
          self.tempoTotalINSSProfessor = self.tempoTotalINSSProfessor + +item.tempo_bruto
        }
      }
    }
    await self.spinner.hide()
    
    // Processar dados para o gráfico timeline
    self.processarDadosTimeline()
    
    // Carregar estatísticas
    await self.carregarEstatisticas()
  }
  
  get exibeSemMatricula(): boolean {
    return this.todosTempos.some(item => item.id_matricula == null)
  }

  contarTemposMatricula(idMatricula?: number): number {
    if (idMatricula == null) {
      return this.todosTempos.filter(item => item.id_matricula == null).length
    }
    return this.todosTempos.filter(item => Number(item.id_matricula) === Number(idMatricula)).length
  }

  filtroMatriculaAtivo(tipo: 'todos' | 'matricula' | 'sem_matricula', idMatricula?: number): boolean {
    if (this.filtroMatricula !== tipo) return false
    return tipo !== 'matricula' || Number(this.idMatriculaFiltro) === Number(idMatricula)
  }

  validarFiltroMatriculaAtual(){
    if (this.filtroMatricula === 'matricula') {
      const existe = this.matriculas.some(matricula => Number(matricula.id) === Number(this.idMatriculaFiltro))
      if (!existe) {
        this.filtroMatricula = 'todos'
        this.idMatriculaFiltro = null
      }
    }
    if (this.filtroMatricula === 'sem_matricula' && !this.exibeSemMatricula) {
      this.filtroMatricula = 'todos'
      this.idMatriculaFiltro = null
    }
  }

  getTemposFiltrados(): any[] {
    if (this.filtroMatricula === 'matricula') {
      return this.todosTempos
        .filter(item => Number(item.id_matricula) === Number(this.idMatriculaFiltro))
        .slice()
    }
    if (this.filtroMatricula === 'sem_matricula') {
      return this.todosTempos.filter(item => item.id_matricula == null).slice()
    }
    return this.todosTempos.slice()
  }

  private recalcularResumo(){
    this.tempoTotalCadastrado = 0
    this.tempoTotalAverbado = 0
    this.tempoTotalINSS = 0
    this.tempoTotalINSSAverbado = 0
    this.tempoTotalRPPS = 0
    this.tempoTotalRPPSAverbado = 0
    this.tempoTotalRPPSProfessor = 0
    this.tempoTotalINSSProfessor = 0

    for (const item of this.tempos) {
      this.tempoTotalCadastrado += Number(item.tempo_bruto) || 0
      if (item.averbado == 1) this.tempoTotalAverbado += Number(item.tempo_bruto) || 0
      if (item.rpps_rgps == 0) {
        this.tempoTotalRPPS += Number(item.tempo_bruto) || 0
        if (item.averbado == 1) this.tempoTotalRPPSAverbado += Number(item.tempo_bruto) || 0
        if (item.em_sala_de_aula === 1) this.tempoTotalRPPSProfessor += Number(item.tempo_bruto) || 0
      } else if (item.rpps_rgps == 1) {
        this.tempoTotalINSS += Number(item.tempo_bruto) || 0
        if (item.averbado == 1) this.tempoTotalINSSAverbado += Number(item.tempo_bruto) || 0
        if (item.em_sala_de_aula === 1) this.tempoTotalINSSProfessor += Number(item.tempo_bruto) || 0
      }
    }
  }

  async selecionarFiltroMatricula(tipo: 'todos' | 'matricula' | 'sem_matricula', idMatricula?: number) {
    this.filtroMatricula = tipo
    this.idMatriculaFiltro = tipo === 'matricula' ? Number(idMatricula) : null
    this.validarFiltroMatriculaAtual()
    this.tempos = this.getTemposFiltrados()
    this.page = 1
    this.selectedTempos.clear()
    this.selectAll = false
    this.recalcularResumo()
    this.processarDadosTimeline()
    this.atualizarUrlFiltroMatricula()
    await this.carregarEstatisticas()
  }

  private atualizarUrlFiltroMatricula(){
    const queryParams: any = {
      filtro_matricula: this.filtroMatricula === 'todos' ? null : this.filtroMatricula,
      id_matricula: this.filtroMatricula === 'matricula' ? this.idMatriculaFiltro : null
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    })
  }

  private getQueryEscopoMatricula(): string {
    let query = '&filtro_matricula=' + this.filtroMatricula
    if (this.idCidade) query += '&id_cidade=' + this.idCidade
    if (this.filtroMatricula === 'matricula') query += '&id_matricula=' + this.idMatriculaFiltro
    return query
  }

  get rotuloFiltroMatricula(): string {
    if (this.filtroMatricula === 'sem_matricula') return 'Sem matrícula'
    if (this.filtroMatricula === 'matricula') {
      const matricula = this.matriculas.find(item => Number(item.id) === Number(this.idMatriculaFiltro))
      return matricula ? String(matricula.matricula) : 'Matrícula'
    }
    return 'Todos'
  }

  get contratosAtuais(): any[] {
    if (!this.filtrarContratosMatricula) return this.todosTempos
    if (this.tempo.id_matricula == null) {
      return this.todosTempos.filter(item => item.id_matricula == null)
    }
    return this.todosTempos.filter(item => Number(item.id_matricula) === Number(this.tempo.id_matricula))
  }

  async carregarEstatisticas() {
    const self = this;
    const requestId = ++self.estatisticasRequestId;
    try {
      const response = await self.apiCall
        .get('servidor/temposervico/estatisticas?id_servidor=' + self.idServidor + self.getQueryEscopoMatricula())
        .pipe(take(1))
        .toPromise();
      
      if (response && requestId === self.estatisticasRequestId) {
        self.estatisticas = response as EstatisticasServidor;
      }
    } catch (error) {
      if (requestId !== self.estatisticasRequestId) return;
      console.error('Erro ao carregar estatísticas:', error);
      // Inicializar com valores zerados se houver erro
      self.estatisticas = self.getEstatisticasVazias();
    }
  }
  
  getEstatisticasVazias(): EstatisticasServidor {
    const itemVazio: DistribuicaoItem = { dias: 0, percentual: 0 };
    const estatisticasContratoVazia: EstatisticasContrato = {
      mais_longo: { dias: 0, percentual: 0 },
      media: 0,
      mediana: 0,
      mais_curto: { dias: 0, percentual: 0 }
    };
    
    return {
      id_servidor: this.idServidor,
      contribuicao_geral: {
        dias_totais: 0,
        total_contratos: 0,
        distribuicao_regime: { rpps: itemVazio, inss: itemVazio },
        distribuicao_tipo: { magisterio: itemVazio, outros: itemVazio },
        averbacao: { averbado: itemVazio, nao_averbado: itemVazio },
        estatisticas_contratos: estatisticasContratoVazia
      },
      contribuicao_inss: {
        dias_totais: 0,
        percentual_do_total: 0,
        total_contratos: 0,
        distribuicao_tipo: { magisterio: itemVazio, outros: itemVazio },
        averbacao: { averbado: itemVazio, nao_averbado: itemVazio },
        estatisticas_contratos: estatisticasContratoVazia
      },
      contribuicao_rpps: {
        dias_totais: 0,
        percentual_do_total: 0,
        total_contratos: 0,
        distribuicao_tipo: { magisterio: itemVazio, outros: itemVazio },
        averbacao: { averbado: itemVazio, nao_averbado: itemVazio },
        estatisticas_contratos: estatisticasContratoVazia
      },
      contribuicao_magisterio: {
        dias_totais: 0,
        percentual_do_total: 0,
        percentual_vs_nao_magisterio: 0,
        total_contratos: 0,
        distribuicao_regime: { rpps: itemVazio, inss: itemVazio },
        averbacao: { averbado: itemVazio, nao_averbado: itemVazio },
        estatisticas_contratos: estatisticasContratoVazia
      },
      aproveitamento_profissional: {
        dias_uteis_decorridos: 0,
        dias_contribuicao: 0,
        tempo_ocioso: 0,
        percentual_medio_contribuicao: 0
      },
      concomitancia: {
        tem_concomitancia: false,
        dias_concomitantes: 0,
        dias_brutos: 0,
        dias_unicos: 0,
        percentual_sobre_brutos: 0
      }
    };
  }

  // Resposta antiga (sem o bloco novo) cai em "sem dias concomitantes"
  get concomitancia(): Concomitancia {
    return (this.estatisticas && this.estatisticas.concomitancia) || {
      tem_concomitancia: false,
      dias_concomitantes: 0,
      dias_brutos: 0,
      dias_unicos: 0,
      percentual_sobre_brutos: 0
    };
  }
  
  // Método auxiliar para calcular percentual de contribuição
  calcularPercentualContribuicao(): number {
    if (!this.estatisticas || !this.estatisticas.aproveitamento_profissional) {
      return 0;
    }
    const aproveitamento = this.estatisticas.aproveitamento_profissional;
    if (aproveitamento.dias_uteis_decorridos === 0) {
      return 0;
    }
    return (aproveitamento.dias_contribuicao / aproveitamento.dias_uteis_decorridos) * 100;
  }
  
  // Método auxiliar para calcular percentual de tempo ocioso
  calcularPercentualTempoOcioso(): number {
    if (!this.estatisticas || !this.estatisticas.aproveitamento_profissional) {
      return 0;
    }
    const aproveitamento = this.estatisticas.aproveitamento_profissional;
    if (aproveitamento.dias_uteis_decorridos === 0) {
      return 0;
    }
    return (aproveitamento.tempo_ocioso / aproveitamento.dias_uteis_decorridos) * 100;
  }
  
  // Método auxiliar para calcular percentual médio de contribuição
  calcularPercentualMedioContribuicao(): number {
    if (!this.estatisticas || !this.estatisticas.aproveitamento_profissional) {
      return 0;
    }
    const aproveitamento = this.estatisticas.aproveitamento_profissional;
    if (aproveitamento.percentual_medio_contribuicao > 0) {
      return aproveitamento.percentual_medio_contribuicao;
    }
    // Se não vier calculado, calcular baseado em dias_contribuicao / dias_uteis_decorridos
    if (aproveitamento.dias_uteis_decorridos === 0) {
      return 0;
    }
    return (aproveitamento.dias_contribuicao / aproveitamento.dias_uteis_decorridos) * 100;
  }

  ngAfterViewInit() {
    // Aguardar o carregamento do ApexCharts
    this.aguardarApexCharts();
  }

  aguardarApexCharts() {
    let tentativas = 0;
    const maxTentativas = 50; // 5 segundos máximo
    
    const verificarApexCharts = () => {
      tentativas++;
      
      if (typeof ApexCharts !== 'undefined') {
        console.log('ApexCharts encontrado, renderizando gráfico...');
        this.renderizarGrafico();
      } else if (tentativas < maxTentativas) {
        setTimeout(verificarApexCharts, 100);
      } else {
        console.error('ApexCharts não foi carregado após 5 segundos');
        // Tentar carregar novamente
        this.carregarApexChartsManualmente();
      }
    };
    
    // Aguardar um pouco mais para garantir que o DOM esteja pronto
    setTimeout(verificarApexCharts, 500);
  }

  carregarApexChartsManualmente() {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/apexcharts@3.35.0/dist/apexcharts.min.js';
    script.onload = () => {
      console.log('ApexCharts carregado manualmente');
      this.renderizarGrafico();
    };
    script.onerror = () => {
      console.error('Erro ao carregar ApexCharts manualmente');
    };
    document.head.appendChild(script);
  }

  renderizarGrafico() {
    // Verificar se ApexCharts está disponível
    if (typeof ApexCharts === 'undefined') {
      console.error('ApexCharts não está carregado');
      return;
    }
    
    if (this.chart) {
      this.chart.destroy();
    }
    
    const chartElement = document.querySelector("#timelineChart");
    if (chartElement) {
      this.chart = new ApexCharts(chartElement, this.chartOptions);
      this.chart.render();
    }
  }

  processarDadosTimeline() {
    const rppsData = [];
    const inssData = [];
    
    this.tempos.forEach((tempo, index) => {
      const startDate = new Date(tempo.data_entrada);
      const endDate = new Date(tempo.data_fim);
      
      const dataPoint = {
        x: tempo.nome_empregrador || `Empregador ${index + 1}`,
        y: [startDate.getTime(), endDate.getTime()],
        cnpj: tempo.cnpj_cpf_empregador,
        empregador: tempo.nome_empregrador,
        tipo: tempo.rpps_rgps === 0 ? 'RPPS' : 'INSS',
        averbado: tempo.averbado === 1 ? 'Sim' : 'Não',
        matricula: tempo.matricula,
        dias: tempo.tempo_bruto
      };
      
      if (tempo.rpps_rgps === 0) {
        rppsData.push(dataPoint);
      } else if (tempo.rpps_rgps === 1) {
        inssData.push(dataPoint);
      }
    });
    
    // Aplicar filtro baseado na seleção do usuário
    this.aplicarFiltroDados(rppsData, inssData);
    
    // Renderizar o gráfico se já estiver inicializado
    if (this.chart) {
      this.renderizarGrafico();
    }
  }

  aplicarFiltroDados(rppsData: any[], inssData: any[]) {
    switch (this.filtroEixo) {
      case 'rpps':
        this.chartOptions.series = [
          {
            name: 'RPPS',
            data: rppsData
          },
          {
            name: 'INSS',
            data: [] // Manter série vazia para preservar o seletor
          }
        ];
        break;
      case 'inss':
        this.chartOptions.series = [
          {
            name: 'RPPS',
            data: [] // Manter série vazia para preservar o seletor
          },
          {
            name: 'INSS',
            data: inssData
          }
        ];
        break;
      default: // 'todos'
        this.chartOptions.series = [
          {
            name: 'RPPS',
            data: rppsData
          },
          {
            name: 'INSS',
            data: inssData
          }
        ];
        break;
    }
  }

  aplicarFiltroEixo(tipo: string) {
    this.filtroEixo = tipo;
    this.processarDadosTimeline();
  }

  /**
   * Ao voltar para a aba "Linha do Tempo", re-renderiza o gráfico.
   * O conteúdo da aba pode ter sido destruído/ocultado ao trocar de aba,
   * então o ApexCharts precisa ser desenhado novamente no DOM visível.
   */
  onTabChange(event: { nextId: string; prevId: string; preventDefault: () => void }) {
    const idAbaLinhaTempo = 'tabLinhaTempo';
    if (event.nextId === idAbaLinhaTempo) {
      // Pequeno delay para o DOM da aba estar visível antes de renderizar
      setTimeout(() => this.renderizarGrafico(), 50);
    }
  }

  getBeautifulDate(date){
    const data = moment(date)
    return date && data.isValid() ? data.format('DD/MM/YYYY') : '—'
  }
isTempoCerto() {
  if (this.tempo.data_entrada && this.tempo.data_fim) {
    return moment(this.tempo.data_entrada, 'DDMMYYYY')
      .isSameOrBefore(moment(this.tempo.data_fim, 'DDMMYYYY'));
  }

  return true;
}

  returnPage(){
    window.history.back();
  }

  private get chaveConferenciaTsp(): string {
    return `census-tsp-conferido-${this.idServidor || 'sem-servidor'}`;
  }

  private carregarConferenciaLocal(){
    if (!this.isConferidor || !this.idServidor) return;
    this.tspConferido = sessionStorage.getItem(this.chaveConferenciaTsp) === '1';
  }

  salvarConferenciaLocal(conferido?: boolean){
    if (!this.isConferidor || !this.idServidor) return;
    if (conferido !== undefined) this.tspConferido = conferido;
    sessionStorage.setItem(this.chaveConferenciaTsp, this.tspConferido ? '1' : '0');
  }

  marcarConferidoEVoltar(){
    this.tspConferido = true;
    this.salvarConferenciaLocal();
    this.returnPage();
  }

  resetaCertidao(){
    this.certidaoEmEdicao = {
      id: null,
      numero_certidao: null,
      data_certidao: null,
    }
  }
  async atualizarCertidao(modal){
    const self = this;
    if(!self.certidaoEmEdicao.id || !self.certidaoEmEdicao.numero_certidao || !self.certidaoEmEdicao.data_certidao){

    }
    await self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.certidaoEmEdicao.data_certidao = this.preparaData(this.certidaoEmEdicao.data_certidao)

    await self.apiCall.get(`servidor/temposervico/certidao/editar?id=${self.certidaoEmEdicao.id}&data_certidao=${self.certidaoEmEdicao.data_certidao}&numero_certidao=${self.certidaoEmEdicao.numero_certidao}`).pipe(take(1)).toPromise()
    await self.spinner.hide()
    await this.app.alert('Tudo certo!', 'Certidão atualizada com sucesso!', 'success')
    self.resetaCertidao()
    modal.close('Close click')
    await self.ngOnInit()
  }
  
  async deletarTempo(id){
    const self = this
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    if (await self.app.confirm(`Atenção`, `Você deseja mesmo deletar este tempo de serviço?`, `Deletar`)) {
      const deleteDependente = await self.apiCall.get(`servidor/temposervico/deletar?id_tempo=${id}`).pipe(take(1)).toPromise()
      console.log(deleteDependente)
      await self.app.alert(`Sucesso`, `Tempo de serviço deletado!`, `success`)
      await self.spinner.hide()
      await self.ngOnInit()
    }
  }
  resetaTempo(){
    this.tempoSubmetido = false
    this.tempo = {
      id: null,
      id_servidor: null,
      id_matricula: null,
      cnpj_cpf_empregador: null,
      numero_certidao: null,
      data_certidao: null,
      nome_empregrador: null,
      data_entrada: null,
      rpps_rgps: 0,
      averbado: 0, // default "Não" (boolean: 1 = Sim, 0 = Não)
      tempo_total: null,
      data_fim: null,
      tempo_bruto: null,
      seq: null,
      em_sala_de_aula: 2
    }
  }
  async atualizarOuCadastrar(modal){
    const self = this
    if(!self.tempo || !self.idServidor){
      return
    }
    if(!self.validarTempo()){
      return
    }
    self.salvandoTempo = true
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    try {
      const dataEntrada  = this.preparaData(this.tempo.data_entrada)
      const dataFim      = this.preparaData(this.tempo.data_fim)
      const dataCertidao = this.preparaData(this.tempo.data_certidao)
      const eraEdicao = !!self.tempo.id
      const idMatriculaParam = self.tempo.id_matricula == null ? '' : self.tempo.id_matricula
      const escopoMatricula = '&id_cidade=' + (self.idCidade || '') + '&id_matricula=' + idMatriculaParam
      let retorno
      if(self.tempo.id){
        retorno = await self.apiCall.get(`servidor/temposervico/editar?id_servidor=${self.idServidor}&id_tempo=${self.tempo.id}&numero_certidao=${self.tempo.numero_certidao}&data_certidao=${dataCertidao}&cnpj_cpf_empregador=${self.tempo.cnpj_cpf_empregador}&nome_empregrador=${self.tempo.nome_empregrador}&data_entrada=${dataEntrada}&data_fim=${dataFim}&tempo_bruto=${self.tempo.tempo_bruto}&rpps_rgps=${self.tempo.rpps_rgps}&averbado=${self.tempo.averbado}&em_sala_de_aula=${self.tempo.em_sala_de_aula}&seq=${self.tempo.seq}` + escopoMatricula).pipe(take(1)).toPromise()
      }else{
        retorno = await self.apiCall.get(`servidor/temposervico/novo?id_servidor=${self.idServidor}&numero_certidao=${self.tempo.numero_certidao}&data_certidao=${dataCertidao}&cnpj_cpf_empregador=${self.tempo.cnpj_cpf_empregador}&nome_empregrador=${self.tempo.nome_empregrador}&data_entrada=${dataEntrada}&data_fim=${dataFim}&tempo_bruto=${self.tempo.tempo_bruto}&rpps_rgps=${self.tempo.rpps_rgps}&averbado=${self.tempo.averbado}&em_sala_de_aula=${self.tempo.em_sala_de_aula}&seq=${self.tempo.seq}` + escopoMatricula).pipe(take(1)).toPromise()
      }
      // O backend reordena os seqs por data de início e retorna o seq final deste registro.
      const seqInfo = retorno && retorno.seq ? ` (Seq ${retorno.seq})` : ''
      await this.app.alert('Tudo certo!', (eraEdicao ? 'Tempo de Serviço atualizado com sucesso!' : 'Tempo de Serviço cadastrado com sucesso!') + seqInfo, 'success')
      modal.close('Close click')
      await self.ngOnInit()
    } catch (error) {
      await self.app.alert('Erro', error && error.message ? error.message : 'Não foi possível salvar o tempo de serviço.', 'error')
    } finally {
      self.salvandoTempo = false
      await self.spinner.hide()
    }
  }
  openCertidao(content, certidao){
    this.resetaCertidao()
    if(certidao){
      this.certidaoEmEdicao = {
        id: certidao.id,
        numero_certidao: certidao.numero,
        data_certidao: moment(certidao.data).format('DDMMYYYY'),
      }
    }
    const modal = this.modalService.open(content, { centered: true, size: "xl" })
  }
  openModalXl(content, tempo, tipo = null){
    this.resetaTempo()
    this.filtrarContratosMatricula = false
    if (!tempo && this.filtroMatricula === 'matricula') {
      this.tempo.id_matricula = this.idMatriculaFiltro
    }
    if(tempo){
      this.tempo = {...tempo}
      this.tempo.data_entrada = moment(this.tempo.data_entrada).format('DDMMYYYY')
      this.tempo.data_fim = moment(this.tempo.data_fim).format('DDMMYYYY')
    }
    if(tipo!=null){
      this.tempo.rpps_rgps = tipo
    }
    // O seq é derivado da ordem por data de início (read-only). Mostra a posição prevista;
    // o backend é a fonte de verdade ao salvar.
    this.recalculaSeqPrevisto()
    console.log(this.tempo)
    const modal = this.modalService.open(content, {
      centered: true,
      size: "xl",
      backdrop: "static",
      windowClass: "tempo-contribuicao-modal-window"
    })
  }
  selecionarRegime(tipo: number){
    this.tempo.rpps_rgps = tipo;
  }

  private tempoVazio(valor: any): boolean {
    return valor === null || valor === undefined ||
      (typeof valor === 'string' && valor.trim() === '')
  }

  erroCampoTempo(campo: string): string {
    if(!this.tempoSubmetido){
      return null
    }

    const nomes = {
      cnpj_cpf_empregador: 'CNPJ/CPF Empregador',
      nome_empregrador: 'Nome Empregador',
      data_entrada: 'Data Início',
      data_fim: 'Data Fim',
      tempo_bruto: 'Tempo Bruto (dias)',
      rpps_rgps: 'Regime de Contribuição',
      averbado: 'Averbação',
      em_sala_de_aula: 'Tempo em sala de aula'
    }
    if(this.tempoVazio(this.tempo[campo])){
      return `O campo ${nomes[campo]} é obrigatório.`
    }
    if((campo === 'data_entrada' || campo === 'data_fim') &&
       !moment(this.tempo[campo], 'DDMMYYYY', true).isValid()){
      return 'Informe uma data válida.'
    }
    if((campo === 'data_entrada' || campo === 'data_fim') && !this.isTempoCerto()){
      return 'A data de início deve ser anterior ou igual à data final.'
    }
    return null
  }

  validarTempo(): boolean {
    this.tempoSubmetido = true
    const campos = [
      'cnpj_cpf_empregador',
      'nome_empregrador',
      'data_entrada',
      'data_fim',
      'tempo_bruto',
      'rpps_rgps',
      'averbado',
      'em_sala_de_aula'
    ]
    const primeiroInvalido = campos.find(campo => !!this.erroCampoTempo(campo))
    if(primeiroInvalido){
      setTimeout(() => {
        const elemento = document.querySelector(`.tempo-contribuicao-form [name="${primeiroInvalido}"]`) as HTMLElement
        if(elemento){
          elemento.focus()
        }
      }, 0)
      return false
    }
    return true

  }
  // Replica a regra de ordenação do backend para prever o seq exibido no modal:
  // usa a data inicial válida ou, na ausência dela, a data final; sem datas, vai para o fim.
  comparaTempoServico(a, b){
    const aIni = a.inicio && a.inicio.isValid() ? a.inicio : null
    const bIni = b.inicio && b.inicio.isValid() ? b.inicio : null
    const aFim = a.fim && a.fim.isValid() ? a.fim : null
    const bFim = b.fim && b.fim.isValid() ? b.fim : null
    const aData = aIni || aFim
    const bData = bIni || bFim
    if(aData && bData){
      const d = aData.diff(bData)
      if(d !== 0) return d
    } else if(aData && !bData){
      return -1
    } else if(!aData && bData){
      return 1
    }
    return (a.id || 0) - (b.id || 0)
  }
  recalculaSeqPrevisto(){
    const entradaAtual = this.tempo.data_entrada ? moment(this.tempo.data_entrada, 'DDMMYYYY') : null
    const fimAtual = this.tempo.data_fim ? moment(this.tempo.data_fim, 'DDMMYYYY') : null
    const temEntradaValida = entradaAtual && entradaAtual.isValid()
    const temFimValido = fimAtual && fimAtual.isValid()
    if(!temEntradaValida && !temFimValido){
      // Sem nenhuma data válida, o backend posiciona no fim.
      return
    }
    const itemAtual = {
      id: this.tempo.id || Number.MAX_SAFE_INTEGER, // novo registro = criado por último
      inicio: entradaAtual,
      fim: fimAtual,
      atual: true
    }
    const lista = (this.todosTempos || [])
      .filter(t => !this.tempo.id || t.id !== this.tempo.id)
      .map(t => ({
        id: t.id,
        inicio: t.data_entrada ? moment(t.data_entrada) : null,
        fim: t.data_fim ? moment(t.data_fim) : null,
        atual: false
      }))
    lista.push(itemAtual)
    lista.sort((a, b) => this.comparaTempoServico(a, b))
    this.tempo.seq = lista.findIndex(x => x.atual) + 1
  }

  cancelTempo(content){
    this.resetaTempo()   
    content.close('Close click')
  }

  calculaTempoBruto(){
    if(this.tempo.data_entrada && this.tempo.data_fim){
      const entrada = moment(this.tempo.data_entrada, 'DDMMYYYY')
      const fim = moment(this.tempo.data_fim, 'DDMMYYYY')
      const diferenca = fim.diff(entrada, 'days')
      this.tempo.tempo_bruto = diferenca.toString()
    }
    // As datas definem a ordem (seq); recalcula a posição prevista.
    this.recalculaSeqPrevisto()
  }
  preparaData(data){
    if(data){
      return moment(data, 'DDMMYYYY').format('YYYY-MM-DD')
    }else{
      data = ''
    }
    return data
  }

  formatarCpfCnpj(valor): string {
    if (valor === null || valor === undefined || valor === '') return '';

    const original = String(valor);
    // Não interpreta matrículas, CEI ou outros identificadores alfanuméricos.
    if (!/^[\d.\-\/\s]+$/.test(original)) return original;

    const apenasNumeros = original.replace(/\D/g, '');
    if (apenasNumeros.length === 8) {
      return apenasNumeros.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2.$3');
    }
    if (apenasNumeros.length === 11) {
      return apenasNumeros.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }
    if (apenasNumeros.length === 14) {
      return apenasNumeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }

    return original;
  }

  // Colunas cujo valor é numérico. Compará-las como texto ordenava
  // 1, 10, 11 … 19, 2, 20 em vez de 1, 2 … 10, 11.
  private static readonly COLUNAS_NUMERICAS = ['seq', 'linha', 'tempo_bruto', 'rpps_rgps', 'em_sala_de_aula'];
  // Datas chegam da API como Date (o endpoint não usa DATE_FORMAT), e como texto
  // seriam ordenadas pelo nome do dia da semana ("wed jul 01 2026…").
  private static readonly COLUNAS_DATA = ['data_entrada', 'data_fim'];

  // Compara valores respeitando o tipo da coluna. O `fator` (1 asc / -1 desc) é aplicado
  // só à comparação dos valores: nulos e valores inválidos ficam sempre no fim da lista,
  // independente da direção da ordenação.
  private comparaColuna(a, b, column: string, fator: number = 1): number {
    if (TemposComponent.COLUNAS_NUMERICAS.indexOf(column) !== -1) {
      const na = a === null || a === undefined || a === '' ? NaN : Number(a);
      const nb = b === null || b === undefined || b === '' ? NaN : Number(b);
      const aVazio = isNaN(na);
      const bVazio = isNaN(nb);
      if (aVazio && bVazio) return 0;
      if (aVazio) return 1;
      if (bVazio) return -1;
      return fator * (na - nb);
    }

    if (TemposComponent.COLUNAS_DATA.indexOf(column) !== -1) {
      const ma = a ? moment(a) : null;
      const mb = b ? moment(b) : null;
      const aVazio = !ma || !ma.isValid();
      const bVazio = !mb || !mb.isValid();
      if (aVazio && bVazio) return 0;
      if (aVazio) return 1;
      if (bVazio) return -1;
      return fator * ma.diff(mb);
    }

    const sa = a === null || a === undefined ? '' : a.toString();
    const sb = b === null || b === undefined ? '' : b.toString();
    if (!sa && !sb) return 0;
    if (!sa) return 1;
    if (!sb) return -1;
    return fator * sa.localeCompare(sb, 'pt-BR', { sensitivity: 'base', numeric: true });
  }

  // Ordem padrão da tela: seq crescente, desempatando por id (registros de
  // importações antigas podem ter seq nulo).
  private comparaPorSeq(a, b): number {
    const porSeq = this.comparaColuna(a ? a.seq : null, b ? b.seq : null, 'seq');
    if (porSeq !== 0) return porSeq;
    return this.comparaColuna(a ? a.id : null, b ? b.id : null, 'seq');
  }

  sortTable(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    const fator = this.sortDirection === 'asc' ? 1 : -1;

    this.tempos.sort((a, b) => {
      let valueA, valueB;

      if (column === 'linha') {
        // Ordenação pelo número da linha original
        valueA = a.numeroLinha;
        valueB = b.numeroLinha;
      } else if (column === 'matricula') {
        valueA = a.matricula || '';
        valueB = b.matricula || '';
      } else if (column === 'status') {
        valueA = a;
        valueB = b;
      } else {
        valueA = a[column];
        valueB = b[column];
      }

      return this.comparaColuna(valueA, valueB, column, fator);
    });
  }

  // Métodos para seleção múltipla
  toggleSelectAll() {
    if (this.selectAll) {
      this.selectedTempos.clear();
      this.selectAll = false;
    } else {
      this.tempos.forEach(tempo => {
        this.selectedTempos.add(tempo.id);
      });
      this.selectAll = true;
    }
  }

  toggleSelectTempo(tempoId: number) {
    if (this.selectedTempos.has(tempoId)) {
      this.selectedTempos.delete(tempoId);
    } else {
      this.selectedTempos.add(tempoId);
    }
    
    // Atualizar estado do selectAll
    this.selectAll = this.selectedTempos.size === this.tempos.length;
  }

  isTempoSelected(tempoId: number): boolean {
    return this.selectedTempos.has(tempoId);
  }

  get selectedTemposCount(): number {
    return this.selectedTempos.size;
  }

  async deletarTemposSelecionados() {
    const self = this;
    
    if (self.selectedTempos.size === 0) {
      await self.app.alert('Atenção', 'Nenhum tempo foi selecionado para exclusão.', 'warning');
      return;
    }

    // Abrir modal de confirmação customizada
    const modalRef = this.modalService.open(this.confirmDeleteModal, { 
      centered: true, 
      size: 'md',
      backdrop: 'static',
      keyboard: false
    });
  }

  async confirmarExclusao(modal) {
    const self = this;
    
    await self.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    try {
      const idsArray = Array.from(self.selectedTempos);
      const response = await self.apiCall.post('servidor/temposervico/deletar/bulk', {
        ids_tempo: idsArray
      }).pipe(take(1)).toPromise();

      console.log('Bulk delete response:', response);
      
      // Limpar seleções
      self.selectedTempos.clear();
      self.selectAll = false;
      
      modal.close('Confirm click');
      await self.app.alert('Sucesso', `${idsArray.length} tempo(s) de serviço deletado(s) com sucesso!`, 'success');
      await self.ngOnInit();
    } catch (error) {
      console.error('Erro ao deletar tempos:', error);
      await self.app.alert('Erro', 'Ocorreu um erro ao deletar os tempos selecionados.', 'error');
    } finally {
      await self.spinner.hide();
    }
  }
}
